import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { IMlmRank } from 'interfaces'
import { QueryCacheKeys } from 'enums'
import { UserService } from 'services'
import * as userSelectors from 'containers/User/user-selectors'
import { getRequestError } from 'utils/helpers'

export type TError = string
export type TQueryKey = string[]
export type TQueryFnOpts = UseQueryOptions<IMlmRank[], TError, IMlmRank[], TQueryKey>

const key = QueryCacheKeys.mlmRankStats

/**
 * Хук API сводная статистика по количеству активных рангов
 */
export default function useFetchMlmRankStats({
    cacheTime = 600 * 1000, // 10m
    staleTime = 600 * 1000, // 10m
    ...opts
}: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`], () => {
        return UserService.fetchMlmRankStats()
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject(getRequestError(err) || t('update_error'))
            })
    }, {
        cacheTime,
        staleTime,
        ...opts,
    })
}
